<template>
    <div class="confirmPassword">
        <el-input :type="inputType" v-model="inputValue"  placeholder="Confirm New Password" maxlength='16' autocomplete="new-password">
            <template slot="suffix">
                <img v-if="isShow" @click="changeShow" class="right_icon" src="@/assets/pc/mask-outline.svg" />
                <img v-if="!isShow" @click="changeShow" class="right_icon" src="@/assets/pc/Icon - Unmask@3x.png" />
            </template>
        </el-input>
    </div>
</template>
<script>
export default {
    name: 'ConfirmPassword',
    props:{
        value:[String, Number]
    },
    data() {
        return {
            inputValue: '',
            isShow: true,
            inputType: 'password'
        }
    },
    watch: {
        value:function(val) {
            this.inputValue = val
        },
        inputValue:function(val) {
            this.$emit('input', val)
        }
    },
    methods: {
        changeShow() {
            this.isShow = !this.isShow
            if (this.isShow) {
            this.inputType = 'password'
            } else {
            this.inputType = 'text'
            }
        }
    }

}
</script>
<style lang="scss" scoped>
.confirmPassword {
    .right_icon {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-top: 7px;
        cursor: pointer;
    }
}
</style>